module.exports = flarum.core.compat['utils/extract'];